package com.bikompanion.ui.models

/**
 * How much the numbers on screen can be trusted.
 *
 * Separate from [RefreshStatus] because the two answer different questions: the status says
 * what the loop is doing right now, this says how old what you are looking at actually is.
 * A countdown ticking away over stale numbers is the exact thing this exists to prevent.
 */
data class DataFreshness(
    /** When the displayed numbers were last read from the operator, in epoch milliseconds. */
    val updatedAtEpochMillis: Long? = null,
    /** True once a refresh cycle has failed and no good one has followed it. */
    val isStale: Boolean = false,
    /**
     * True when the failure behind [isStale] was the data source refusing further requests,
     * rather than e.g. being offline — worth telling the rider apart, since this one resolves
     * itself on a timer rather than needing a working connection.
     */
    val isRateLimited: Boolean = false,
)
